// This is currently not being used, but I'm leaving it in the repo because I think Solv may want to use it in the future. 2/10/2023 -Alan

import { trackSegmentEvent } from '~/components/shared/tracking/segmentAnalytics';
import { createIntersectionObsv } from '../../../shared/utilities';

function b2cSegmentDataHelper() {
  const dataset = document.body.dataset;
  const width = window.innerWidth;
  const isMobile = width < 769;
  const datePublished = dataset.articlePublished;
  const dateUpdated = dataset.articleUpdated;
  const contentCategory = dataset.contentCategory;
  const hasImage = dataset.articleImage === 'true';
  const wordCount = parseInt(dataset.articleWordCount);
  const author = dataset.articleAuthor;
  const specialty = dataset.articleSpecialty;
  const articleTitle = dataset.articleTitle;

  const getPageAndCategory = () => {
    const action = dataset.action;
    const controller = dataset.controller;
    const result = {
      pageType: 'index',
      contentType: 'blog',
    };

    // determine PageType
    if (action.indexOf('show') > -1) {
      result.pageType = 'article';
    } else if (action.indexOf('category') > -1) {
      result.pageType = 'category';
    }

    // determine Category Type
    if (controller === 'b2c-health_library') {
      result.contentType = 'health a-z';
    }

    return result;
  };

  const { pageType, contentType } = getPageAndCategory();

  return {
    isMobile: isMobile,
    page_type: pageType,
    content_category: contentCategory,
    content_type: contentType,
    date_published: datePublished,
    date_updated: dateUpdated,
    image: hasImage,
    word_count: wordCount,
    author: author,
    specialty: specialty,
    article_title: articleTitle,
  };
}

const sharedContentData = b2cSegmentDataHelper();
//solv plus or ad tracking

// load event
trackSegmentEvent('Content - Load', {
  action: 'load page',
  ...sharedContentData,
});

const contentCTAEl = document.querySelector('.b2c-content-cta');
// content side cta
if (contentCTAEl) {
  // load event
  if (!sharedContentData.isMobile) {
    trackSegmentEvent('Content - CTA', {
      action: 'load',
      cta_location: 'body',
      cta_topic: 'book online',
      ...sharedContentData,
    });
  }
  // view event
  const intersectionFn = trackSegmentEvent.bind(null, 'Content - CTA', {
    action: 'view',
    cta_location: 'body',
    cta_topic: 'book online',
    ...sharedContentData,
  });
  const observer = createIntersectionObsv(contentCTAEl, intersectionFn);
  observer.observe(contentCTAEl);

  // click event
  const buttonEl = contentCTAEl.querySelector('.b2c_toggle_button');
  buttonEl.addEventListener('click', (e) => {
    trackSegmentEvent('Content - CTA', {
      action: 'click',
      cta_location: 'body',
      cta_topic: 'book online',
      ...sharedContentData,
    });
  });
}

// Content - Search
const sideForm = document.querySelector('.cta-form-container form');
if (sideForm) {
  const submitButton = sideForm.querySelector('form button[type="submit"]');
  if (submitButton) {
    submitButton.addEventListener('click', (e) => {
      const formData = {};
      sideForm.querySelectorAll('input, select').forEach((n) => {
        formData[n.name] = n.value;
      });
      const segmentProps = {
        action: 'clicks find care form',
        reason: formData['reasonForVisit'],
        time: formData['appointmentTime'],
        patient: formData['patientType'],
      };
      trackSegmentEvent('Content - Search', {
        ...segmentProps,
        ...sharedContentData,
      });
    });
  }
}

// Content - Article
document
  .querySelectorAll('.post-body .post-content a:not(.button)')
  .forEach((a) => {
    a.addEventListener('click', (e) => {
      trackSegmentEvent('Content - Article', {
        action: 'link',
        link_text: a.innerText,
        link_address: a.href,
        ...sharedContentData,
      });
    });
  });

// Content - Solv App CTA
document.querySelectorAll('.solv_app_cta .button').forEach((a) => {
  a.addEventListener('click', (e) => {
    trackSegmentEvent('Content - CTA', {
      action: 'click',
      cta_location: 'body',
      cta_topic: 'app download',
      cta_type: 'button',
      ...sharedContentData,
    });
  });
});
